import React, { CSSProperties } from 'react';

export type AlertType = 'warning' | 'info' | 'danger' | 'success';

interface IAlertProps {
    type: AlertType;
    message: string;
    label?: string;
    iconSize?: number;
    closable?: boolean;
    onClose?: () => void;
}

const alert = ({ type, message, iconSize = 1, closable = false, onClose }: IAlertProps): JSX.Element => {
    const customStyles = { '--icon-size': `${iconSize}rem` };
    return (
        <div className={`msc-alert msc-alert-${type}`} role='alert'>
            <span className='msc-alert__message' style={customStyles as CSSProperties}>
                {message}
            </span>
            {closable && <button aria-label='close' className='msc-alert__close' onClick={onClose} />}
        </div>
    );
};

export default alert;
